import { render, staticRenderFns } from "./BulkActionMoveIcon.vue?vue&type=template&id=42cfb17a"
import script from "./BulkActionMoveIcon.vue?vue&type=script&lang=js"
export * from "./BulkActionMoveIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports